import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { Link } from 'react-router-dom';
import { TextButton } from '@ds/react-components';

import * as Styled from './HttpAlertDialog.styled';

const HttpAlertDialog = (props) => {
  const { httpError, localisation, resetHttpError } = props;

  const getAjaxErrorMessage = () => {
    const prompt = localisation.prompts;
    if (!httpError) return prompt.ajaxError_Generic;
    const { status } = httpError;
    return prompt['ajaxError_' + status] || prompt.ajaxError_Generic;
  };

  const alert = {
    showAlert: httpError != null,
    title: localisation.prompts.ajaxErrorTitle,
    text: getAjaxErrorMessage(),
    redirectUrl: '/LogOut',
    buttonText: 'Sign Out',
  };

  return (
    <>
      <Dialog
        open={alert.showAlert}
        onClose={resetHttpError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <Styled.AlertContainer>
          <Styled.AlertTitle id="alert-dialog-title">
            {alert.title}
          </Styled.AlertTitle>
          <Styled.AlertContent id="alert-dialog-description">
            {alert.text}
          </Styled.AlertContent>
          <Styled.AlertFooter>
            <Link to={alert.redirectUrl}>
              <TextButton variant="slighter" onClick={resetHttpError}>
                {alert.buttonText}
              </TextButton>
            </Link>
          </Styled.AlertFooter>
        </Styled.AlertContainer>
      </Dialog>
    </>
  );
};

HttpAlertDialog.propTypes = {
  httpError: PropTypes.shape({
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
  }),
  resetHttpError: PropTypes.func.isRequired,
  localisation: PropTypes.shape({
    prompts: PropTypes.object.isRequired,
  }).isRequired,
};

HttpAlertDialog.defaultProps = {
  httpError: null,
};

export default HttpAlertDialog;
